export const underlyingTickerSymbolList = [
  { value: 'NIFTY 50', label: 'NIFTY' },
  { value: 'NIFTY BANK', label: 'BANKNIFTY' },
  { value: 'NIFTY FIN SERVICE', label: 'FINNIFTY' },
  { value: 'NIFTY MID SELECT', label: 'MIDCPNIFTY' },
  { value: 'SENSEX', label: 'SENSEX' },
  { value: 'BANKEX', label: 'BANKEX' },
];

export const underlyingTickerSymbolListReduced = underlyingTickerSymbolList.map(
  (item) => item.value
);

export const underlyingTickerSymbolListLabel = underlyingTickerSymbolList.map(
  (item) =>
    Object.assign({
      value: item.label,
      label: item.label,
    })
);
